import {useRef, useState} from 'react';
import {ErrorNotice} from './components';
import type {hermesActions} from './lib/store';
import type {HermesState} from './lib/types';

export function WeeklyAllowanceReset({state, actions}: {state: HermesState; actions: typeof hermesActions}) {
  const requestId = useRef(crypto.randomUUID());
  const [review, setReview] = useState(false);
  const balance = state.accountBalance.data;
  const voucher = balance?.resetVoucher;
  const busy = state.operation.label !== null;
  if (!voucher) return null;
  return <section className="billing-section weekly-allowance-reset"><h2>Your extra weekly reset</h2>
    <p>{voucher.usedAt ? 'Your extra reset has been used.' : voucher.available ? `One reset available until ${new Date(voucher.expiresAt).toLocaleDateString()}.` : 'Your unused reset has expired.'}</p>
    {voucher.available && <><p className="billing-note">Start a new weekly allowance now. This replaces any weekly credits you have left. Purchased credits stay available. The new week ends after seven days or at the end of your billing period, whichever comes first.</p>
      {review ? <div><p>Replace your remaining weekly allowance and use your available reset?</p><div className="billing-reset-actions">
        <button className="button" type="button" disabled={busy} onClick={() => void actions.resetWeeklyLimit(requestId.current).then(() => setReview(false)).catch(() => undefined)}>Confirm weekly reset</button>
        <button className="text-button" type="button" disabled={busy} onClick={() => setReview(false)}>Cancel</button>
      </div></div> : <button className="button" type="button" disabled={busy || balance.status !== 'ready' || !balance.allowance} onClick={() => setReview(true)}>Reset weekly allowance</button>}
    </>}
    <ErrorNotice title="Your weekly allowance could not be reset" error={state.operation.scope === 'weekly-reset' ? state.operation.error : null}/>
  </section>;
}
